var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.25C29.8381 12.1576 29.4774 13.0182 28.9438 13.77L17.965 28.545C17.6169 28.9947 17.1712 29.3593 16.6614 29.6113C16.1516 29.8633 15.5912 29.9961 15.0226 29.9996C14.4539 30.0031 13.8919 29.8772 13.3791 29.6315C12.8663 29.3858 12.4161 29.0266 12.0625 28.5813L1.03 13.5C0.56135 12.8209 0.230516 12.0565 0.05625 11.25H7.89125L13.8325 26.6988C13.9229 26.9351 14.0829 27.1385 14.2914 27.2819C14.4999 27.4254 14.7469 27.5022 15 27.5022C15.2531 27.5022 15.5001 27.4254 15.7086 27.2819C15.9171 27.1385 16.0771 26.9351 16.1675 26.6988L22.1088 11.25H30ZM22.125 8.75H29.9463C29.7561 7.90427 29.3912 7.10764 28.875 6.41125L25.6775 2.09375C25.2145 1.44657 24.6038 0.919064 23.8963 0.554949C23.1887 0.190833 22.4045 0.000595795 21.6088 2.41697e-06H18.8587L22.125 8.75ZM13.885 2.41697e-06L10.5613 8.75H19.4512L16.1937 2.41697e-06H13.885ZM7.8875 8.75L11.21 2.41697e-06H8.3075C7.51848 -0.00077429 6.74053 0.185659 6.03757 0.543986C5.3346 0.902313 4.72668 1.42231 4.26375 2.06125L1.1725 6.11375C0.581006 6.88879 0.179431 7.79169 0 8.75H7.8875ZM19.43 11.25H10.57L15 22.7675L19.43 11.25Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProPlan);
export default __webpack_public_path__ + "static/media/icon-pro-plan.8775a39549cc8ec3db7661939fb28eda.svg";
export { ForwardRef as ReactComponent };